<template>
	<div class="ReBacktrace col-6 ">
        <base-button  type="primary" @click="showBacktrace()" class="mb-3" style="padding: 5px;">
            ReBacktrace
        </base-button>

        <card class="BacktraceCard" v-if="isShown==true">
            <p>Hi there!</p>            

            <collapse v-for="(objBackTrace, index) in masBackTrace" :key="index">
                <collapse-item>
                    <template v-slot:title>{{GetLastOktet(objBackTrace.file)}} - {{ GetBackTraceField(objBackTrace,'class') }} - {{ GetBackTraceField(objBackTrace,'function') }} - {{ GetBackTraceField(objBackTrace,'line') }}</template>
                    <div class="col px-0">                                                    
                        <div v-for="(item, index) in objBackTrace" :key="index"> 
                            <div v-if="index == 'object' && index!=''">
                                <p class="BackTraceParams">{{index}}: </p>
                                <collapse v-for="(model, index) in item" :key="index">
                                    <collapse-item>
                                        <template v-slot:title>{{index}}</template>                                                
                                        <!--p>{{model}}</!--p-->   
                                        <collapse v-for="(detail, index) in model" :key="index">
                                            <collapse-item>
                                                <template v-slot:title>{{index}}</template>  
                                                <p>{{detail}}</p>   
                                            </collapse-item>
                                        </collapse>  
                                    </collapse-item>
                                </collapse>  
                            </div> 
                                
                            <div v-else>
                                <p><span class="BackTraceParams"> {{index}}:</span> {{item}}</p>
                            </div>                            
                        </div>                             
                    </div>
                </collapse-item>
            </collapse>
        </card>        
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';

export default {
    name: 'ReBacktrace',
    components: {
        Collapse,
        CollapseItem,        
    },
    props: {
        counter: String,
        findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
            type: String,
            default: '',
        },
        masBackTrace: Array,
        
    },
    data () {
        return {
            ver: 1,            
            isShown: false,                                   
        }
    },   
    computed: {
    },
  
    methods: {
    
	GetBackTraceField(BObj,f_name){
	    if(BObj[f_name]!=undefined){
		return BObj[f_name]
	    }
	    return f_name+': NULL';
	},
    
    GetLastOktet(str){
    let tarr=str.split('/');
    return tarr[tarr.length - 1];
	},
    showBacktrace() {
        this.isShown = !this.isShown;
    },
        // getApiData() {
        //     this.$GVO.ApiCall('GET', { obj:'client',flt:{id:this.$route.params.client_id }})
        //     .then(objApi => {
        //         if (objApi.success === true) {
        //             if (objApi.back_trace_json.length > 0) {
        //                 this.backtracejson = objApi.back_trace_json;                        
        //                 //this.masClient = objApi.data;
        //             }
        //             console.log(objApi.back_trace_json);
        //         }
        //     })
        //     .catch(errorObjApi => console.log(errorObjApi));
        //     },
        }, 
    }
</script>

<style scoped>
.ReBacktrace{z-index: 1100;top: 50px;left: 5px;position: absolute;}
.ReBacktrace >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0!important;}
.ReBacktrace .BackTraceParams {font-size:16px; color: #01B0E0; margin-right: 10px;}
</style>
